<template>
  <div id="app">
    <Header v-if="this.$route.meta.showHeader"></Header>
    <router-view/>
  </div>
</template>

<script>
import Header from "@/layout/Header"
export default {
  components:{
    Header,
  },
  name: 'App',
  data(){
    return{
    }
  },
  created(){
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if(/android|iphone|ipad|ipod/i.test(userAgent)){
      window.location.href=window.globalUrl.env+"/aliyun-hwgw-mobile/#/index"
    }
  }
}
</script>

<style lang="scss">
#app,body,html, h1, h2, h3, h4, h5, h6, p, table, tr, td, ul, li, a, form, input, select, option, textarea {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  margin: 0;
  user-select: none;
}
::-webkit-scrollbar{
  display: none;
}
body{
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
